/* yn-fixes.js: small integration fixes found while testing the assembled theme. Loaded by yn-head, deferred, after yn-core.js. */
(function () {
  if (window.__ynFixes) return;
  window.__ynFixes = true;

  function reduced() {
    return document.documentElement.classList.contains('yn-reduced') ||
      !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* Scroll the product gallery to one of its slides (works in both text directions). */
  function toSlide(track, slide, smooth) {
    if (!track || !slide) return;
    var cs = window.getComputedStyle(track);
    var rtl = cs.direction === 'rtl';
    var pad = parseFloat(rtl ? cs.paddingRight : cs.paddingLeft) || 0;
    var tr = track.getBoundingClientRect(), sr = slide.getBoundingClientRect();
    var delta = rtl ? (sr.right - tr.right + pad) : (sr.left - tr.left - pad);
    if (Math.abs(delta) < 2) return;
    if (smooth && !reduced() && track.scrollBy) { track.scrollBy({ left: delta, behavior: 'smooth' }); return; }
    var prev = track.style.scrollBehavior;
    track.style.scrollBehavior = 'auto';
    track.scrollLeft += delta;
    track.style.scrollBehavior = prev;
  }

  /* Product page: when a colour is selected at load, show that colour's photo.
     (yn-product.js scrolls the gallery when a colour is tapped, but not for the colour chosen at load.) */
  function galleryToColour() {
    var track = document.querySelector('[data-yn-track]');
    var dataEl = document.querySelector('script[data-yn-data]');
    var sw = document.querySelector('[data-yn-colour][aria-pressed="true"]');
    if (!track || !dataEl || !sw) return;
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!D || !D.colourPos || !D.variants) return;
    var val = sw.getAttribute('data-yn-colour');
    var v = D.variants.filter(function (x) { return x.o && x.o[D.colourPos - 1] === val && x.m; })[0];
    if (!v) return;
    toSlide(track, track.querySelector('[data-media-id="' + v.m + '"]'), false);
  }

  /* Product page: the cart count on the buy bar and the bundle's free-shipping note need the cart's
     real state at load. The core only fetches it after the first cart change, so ask for it once here. */
  function cartStateOnProduct() {
    if (!document.querySelector('[data-yn-track], script[data-yn-data]')) return;
    var Y = window.Yuno;
    if (Y && Y.cart && typeof Y.cart.refresh === 'function' && !Y.cart.state) {
      try { Y.cart.refresh(); } catch (e) {}
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    /* Product page, desktop: the photo thumbnails move the gallery. */
    var thumb = t.closest('[data-yn-thumb]');
    if (thumb) {
      var track = document.querySelector('[data-yn-track]');
      if (track) {
        var slides = track.querySelectorAll('[data-slide]');
        var i = parseInt(thumb.getAttribute('data-yn-thumb'), 10);
        if (!isNaN(i) && slides[i]) toSlide(track, slides[i], true);
      }
      return;
    }

    /* A link followed from inside an open sheet replaces the sheet's own history entry,
       so the back button returns to the page she was on in one step. */
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (!document.documentElement.classList.contains('yn-sheet-open')) return;
    var a = t.closest('a[href]');
    if (!a || !a.closest('.yn-sheet')) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('download')) return;
    if (a.hasAttribute('data-yn-sheet-open') || a.hasAttribute('data-yn-sheet-close') || a.hasAttribute('data-yn-cart-open') || a.hasAttribute('data-yn-quick-add')) return;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return;
    if (a.origin !== window.location.origin) return;
    e.preventDefault();
    window.location.replace(a.href);
  }, false);

  function run() {
    try { galleryToColour(); } catch (e) {}
    setTimeout(function () { try { cartStateOnProduct(); } catch (e) {} }, 400);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 60); });
  else setTimeout(run, 60);
  document.addEventListener('shopify:section:load', function () { setTimeout(function () { try { galleryToColour(); } catch (e) {} }, 60); });
})();
